import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { selectModal } from "../../redux/modal/selectors";
import { closeModal } from "../../redux/modal/modalSlice";
import { Toast } from 'devextreme-react/toast'
import { ROUTE_LOGIN } from "../routes/routesConstants";
import { useHistory, useLocation } from "react-router-dom";


function Modal(){

let modal = useSelector(selectModal);
const dispatch = useDispatch()
const history = useHistory()
const location = useLocation();

useEffect(()=>{
  if(modal.code === 401){
   history.push(ROUTE_LOGIN, location.state)
  }
},[modal])
 
function handleClose(){
dispatch(closeModal());
}
    return(
      <Toast
      visible={modal.open}
      message={modal.message}
      type={modal.type}
      onHiding={handleClose}
      displayTime={5000}
    />

    )
}

export {Modal}